import { memo } from 'react';
import { useIntl } from 'react-intl';
import CollapsibleContent from '../../../core/components/CollapsibleContent';
import useSalePage from '../../../core/queries/useSalePage';
import useLoginState from '../../../core/hooks/useLoginState';
import { ProductState } from '../../queries/types';
import CollapsibleSideBarFilterTitle from '../ProductList/Filters/CollapsibleSideBarFilterTitle';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import { useProductListOptionsContext } from '../ProductList/context/ProductListOptionsContext';
import SimpleFilter from './SimpleFilter';

const FilterSaleAndNew = ({ defaultExpand }: { defaultExpand?: boolean }) => {
    const {
        filters: { states },
    } = useProductListOptionsContext();
    const { data } = useSalePage();
    const isLoggedIn = useLoginState();
    const intl = useIntl();

    const showSale = isLoggedIn && !!data;
    return (
        <CollapsibleContent
            expanded={defaultExpand}
            smallIcon
            title={
                <CollapsibleSideBarFilterTitle>
                    {intl.formatMessage({
                        id: 'sales page',
                    })}
                </CollapsibleSideBarFilterTitle>
            }
            endArrow
            filterIcon
        >
            {showSale && (
                <SimpleFilter
                    isChecked={states.includes(ProductState.ON_SALE)}
                    testClass="saleFilterCheckbox"
                    field="onSale"
                    label={data.filter_headline}
                />
            )}

            <SimpleFilter
                isChecked={states.includes(ProductState.IS_NEW)}
                testClass="newFilterCheckbox"
                field="isNew"
                label={intl.formatMessage({
                    id: 'is new',
                })}
            />
        </CollapsibleContent>
    );
};

export default memo(withErrorBoundary(FilterSaleAndNew));
